import { Diez, DesignLanguage } from '@haiku/shibui'

let shibui = new DesignLanguage();

if (typeof document !== 'undefined') {
  new Diez(DesignLanguage).attach((component) => {
    shibui = component;
  });
}

export default {
  colors: shibui.palette.colors,
  colorsMapped: shibui.palette.colorsMapped,
  sizing: shibui.layout.sizing,
  spacing: shibui.layout.spacing,
  borderRadii: shibui.borderRadii,
  typography: shibui.typography,
  shadows: shibui.shadows,
};



// WEBPACK FOOTER //
// ./src/components/assets/shibui.js